/*
 * Copyright 2025 coze-dev Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { addGlobalRequestInterceptor } from './axios';
import {
  getAgentApiGatewayPrefix,
  resolveAgentApiGatewayUrl,
} from './agent-api-gateway-prefix';

/** 为全局 axios 注册 Agent Studio 网关路径前缀（仅注册一次） */
export function registerAgentApiGatewayPrefix(): void {
  if (!getAgentApiGatewayPrefix()) {
    return;
  }
  addGlobalRequestInterceptor(config => {
    if (config.url) {
      config.url = resolveAgentApiGatewayUrl(config.url);
    }
    return config;
  });
}
